export function PageHeader({ title, subtitle, children, testId }) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1
          className="font-heading font-black text-4xl text-[#0F172A] mb-2"
          data-testid={testId}
        >
          {title}
        </h1>
        {subtitle && <p className="text-[#64748B] text-sm">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
